import { createContext, useContext } from 'react'

import { Dialog } from '@orus.eu/pharaoh-next/components/patterns/dialog'

type HelpContactContextValue = {
  handle: ReturnType<typeof Dialog.createHandle>
  openHelpContact: () => void
}

export const HelpContactContext = createContext<HelpContactContextValue | undefined>(undefined)

export function useOpenHelpContact(): () => void {
  const context = useContext(HelpContactContext)
  if (context === undefined) {
    throw new Error('useOpenHelpContact must be used within HelpContact.Root')
  }
  return context.openHelpContact
}

export function useOptionalOpenHelpContact(): (() => void) | undefined {
  return useContext(HelpContactContext)?.openHelpContact
}
